(() => {
  angular
    .module('gm.common.analytics')
    .factory('GmyAdroll', GmyAdroll);

  function GmyAdroll(
    $log,
    $window,
    Environment
  ) {
    'ngInject';

    const TRACK_CODES = {
      SIGN_IN: 'f2df7661',
      DEPOSIT: '5b5f64be',
      RECURRING_DEPOSIT: '16e86732'
    };

    return {
      getAdroll,
      recordUser,
      trackDeposit,
      trackSignUp,
    };

    function getAdroll() {
      return $window.__adroll;
    }

    function recordUser(adrollSegments) {
      if (Environment.settings.adroll.enabled) {
        try {
          getAdroll().record_user({
            adroll_segments: adrollSegments
          });
        } catch (error) {
          $log.debug(error);
        }
      }
    }

    function trackDeposit(isRecurring = false) {
      recordUser(TRACK_CODES.DEPOSIT);

      if (isRecurring) {
        recordUser(TRACK_CODES.RECURRING_DEPOSIT);
      }
    }

    function trackSignUp() {
      recordUser(TRACK_CODES.SIGN_IN);
    }
  }
})();
